// router.js

import { nextTick } from 'vue';

import { createRouter, createWebHistory, START_LOCATION } from 'vue-router';

import store from '@/store/store';

import routes from '@/router/routes';

import { Posthog } from '@/vendors/Posthog';

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      const el = window.location.href.split('#')[1];
      if (el.length) {
        document.getElementById(el).scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else if (savedPosition) {
      return savedPosition;
    } else {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
          block: 'start',
        });
      }, 300);
    }
  },
  routes,
});

// let startTime = new Date();

// This callback runs before every route change, including on page load.
router.beforeEach(async (to, from, next) => {
  // Initial Navigation
  if (from === START_LOCATION) {
    if (to.fullPath !== '/login') {
      store.commit('setQuery', to.query);
    }
  }

  // Auto refresh if greater than 12 hours hold
  // if (new Date().getTime() - startTime.getTime() > 60 * 60 * 12 * 1000) {
  //   window.location.replace(to.fullPath);
  // }

  const requiresAuth = to.matched.some((x) => x.meta.requiresAuth);
  let currentUser = store.state.currentUser;

  if (requiresAuth && !currentUser) {
    store.commit('setQuery', {
      ...to.query,
      redirect: encodeURI(to.path),
    });
    next(`/login`);
  } else if (to.meta.requiresSuperUser) {
    let intervalCount = 0;
    await new Promise((resolve) => {
      const intervalId = setInterval(() => {
        if (store.state.userProfile.id || intervalCount === 100) {
          clearInterval(intervalId);
          resolve();
        }
        intervalCount++;
      }, 150);
    });
    if (store.state.userProfile.type !== 'super-user') {
      next('/404');
    } else {
      next();
    }
  } else if (to.matched.length === 0) {
    next('/404');
  } else {
    next();
  }
  store.commit('appLoaded', true);
});

router.afterEach((to, from, failure) => {
  if (!failure) {
    nextTick(() => {
      Posthog.capture({ event: '$pageview', properties: { path: to.fullPath } });
    });
  }
});

export default router;
